<template>
  <section
    :class="`
      disease-type-v2-pop ${visible ? '' : 'disease-type-v2-pop-hide'}
    `"
    data-stat-id="jbxq"
    data-stat-expose
    @touchstart.stop="touchstart"
    @touchmove.stop="touchmove"
    @animationend="animationEnd"
  >
    <div class="disease-type-v2-search">
      <bxs-icon name="search" />
      <input
        v-model="word"
        type="text"
        data-stat-id="jbxqssk"
        placeholder="请输入病种名称"
        @input="Input"
      >
    </div>
    <!--险种列表-->
    <disease-type-new-nav v-if="list.length > 1" v-model="nav" :list="list" />
    <!--病种列表-->
    <disease-type-new-sub
      v-if="categoryList.length"
      ref="sub"
      v-model="subNav"
      :is-fixed="isFixed"
      :list="categoryList"
    />
    <!--病种详情-->
    <disease-type-new-detail
      v-if="!requesting"
      ref="detail"
      :list="categoryDisease"
      :info="categoryInfo"
      @scroll="Scroll"
    />
  </section>
</template>
<script>
import { Icon } from 'bxs-ui-vue'
import { diseaseV2 } from 'api/index'
import diseaseTypeNewNav from './diseaseTypeNewNav.vue'
import diseaseTypeNewSub from './diseaseTypeNewSub.vue'
import diseaseTypeNewDetail from './diseaseTypeNewDetail.vue'
export default {
  components: { [Icon.name]: Icon, diseaseTypeNewNav, diseaseTypeNewSub, diseaseTypeNewDetail },
  props: {
    // 险种分类
    list: {
      type: Array,
      default: () => []
    },
    // 默认险种序号
    defaultIndex: {
      type: Number,
      default: 0
    },
    // 默认病种id
    defaultCategoryId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: true,
      isFixed: false,
      requesting: false,
      // 关键字搜索
      word: '',
      wordSearch: false,
      nav: 0,
      // 病种分类
      categoryList: [],
      categoryInfo: [],
      categoryDisease: [],
      subNav: 0
    }
  },
  computed: {
    // 当前险种
    current() {
      return this.list[this.nav] || {}
    }
  },
  watch: {
    nav() {
      if (this.$refs.sub) this.$refs.sub.reset()
      this.categoryInfo = []
      // 当有初始化tab(险种)时，第一次不请求，在弹窗动画展开后进行请求
      if (!this.firstReq) return
      this.getDisease()
      this.$emit('update', { type: 'tab-change', index: this.nav})
    },
    subNav() {
      this.categoryInfo = []
      this.getDisease(1)
      if (this.$refs.detail) this.$refs.detail.reset()
      this.$emit('update', { type: 'sub-tab-change', index: this.subNav})
    }
  },
  created() {
    this.addListener(this.close)
    this.nav = this.defaultIndex
  },
  methods: {
    // 给地址栏增加hash记录（页面并不会跳转）用于监听回退
    // 当页面执行回退时，因为之前增加了hash记录，所以页面会退hash记录
    // 页面执行回退动作，会触发popstate事件（可以处理页面回退之前逻辑，模拟回退拦截）
    // 因为监听了popstate事件，所以执行回调函数(关掉弹窗，模拟页面关闭）
    addListener(callback) {
      if (window.history && window.history.pushState) {
        const url = document.URL + '&t=1'
        history.pushState(null, null, url)
        window.addEventListener('popstate', callback, false)
        this.preTitle = document.title
        document.title = '病种详情'
      }
    },
    close(callback) {
      document.title = this.preTitle
      if (this.isBackFormRight) {
        // 当ios左滑回退页面时，无动画关闭pop，直接移除pop
        this.$emit('close')
        return
      }
      // 通过滑动动画关闭pop，兼容动画结束事件，结束后移除pop
      this.visible = false
      // 当由父组件控制关闭时（同屏讲解），需要在关闭动画结束后执行回调
      if (typeof callback === 'function') this.callback = callback
    },
    animationEnd() {
      if (this.visible) {
        this.getDisease()
        return
      }
      // 关闭动画结束之后，有回调执行回调
      if (this.callback) {
        this.callback()
      } else {
        this.$emit('close')
      }
      this.callback = null
    },
    Input(ev) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (ev) this.$emit('update', { type: 'go-search', word: this.word})
        if (!this.word) {
          const obj = this.categoryList[this.subNav]
          if (obj) this.$parent.defaultCategoryId = obj.categoryId
          this.getDisease()
          return
        }
        this.getDisease(1)
      }, 2000)
    },
    // 兼容ios左滑回退
    touchstart(ev) {
      if (!window.appBridge.isIos()) return
      this.startX = ev.touches[0].pageX
      this.startY = ev.touches[0].pageY
      this.isBackFormRight = false
    },
    // 兼容ios左滑回退
    touchmove(ev) {
      if (!window.appBridge.isIos()) return
      const touch = ev.touches[0]
      const ang = Math.atan2(touch.pageY - this.startY, touch.pageX - this.startX) * 180 / (Math.PI)
      this.isBackFormRight = this.startX < 30 && (ang < 10 || ang > 175)
    },
    Scroll(fixed) {
      this.isFixed = fixed
    },
    // 查病种 type不传，查险种，1查病种
    getDisease(type) {
      if (this.requesting) return
      const current = this.current
      const params = {
        insuranceId: current.insuranceId
      }
      if (type) {
        // 查病种
        params.categoryId = this.categoryList[this.subNav].categoryId
      }
      // 查关键字
      if (this.word) params.diseaseName = this.word
      window.appBridge && window.appBridge.showLoading(true)
      diseaseV2(params).then(res => {
        const data = res.data.data || {}
        // 疾病保障
        const _info = data.categoryInfo || {}
        const info = []
        if (_info.totalSecondary) info.push(`分${_info.totalSecondary}类`)
        if (_info.waitingPeriod) info.push(_info.waitingPeriod + '等待期')
        if (_info.payOutNum) info.push(_info.payOutNum)
        if (_info.payoutPercentage) info.push(_info.payoutPercentage)
        if (_info.description) info.push(_info.description)
        this.categoryInfo = info
        this.categoryDisease = []
        this.requesting = false
        // 是否是搜索结果
        this.wordSearch = Boolean(params.diseaseName)
        // 查险种时更新病种列表
        if (data.categoryCount && data.categoryCount.length) this.categoryList = data.categoryCount || []
        // 如果默认查险种且病种非默认第一个，需要再额外查指定病种
        if (!type && this.defaultCategoryId) {
          const idx = this.categoryList.findIndex(item => item.categoryId === this.defaultCategoryId)
          if (idx > -1) this.subNav = idx
          this.$parent.defaultCategoryId = 0
          // 再查指定病种
          this.getDisease(1)
          return
        }
        // 病种详情
        if (data.secondaryDiseaseDTO) {
          Object.keys(data.secondaryDiseaseDTO).forEach(name => {
            this.categoryDisease.push({
              name,
              visible: Boolean(params.diseaseName),
              diseaseDTOS: data.secondaryDiseaseDTO[name]
            })
          })
        } else if (data.diseaseDTOS) {
          this.categoryDisease.push({
            diseaseDTOS: data.diseaseDTOS
          })
        }
        window.appBridge && window.appBridge.hideLoading(true)
      }).catch(e => {
        console.error(e)
      })
      this.requesting = true
      this.firstReq = true
    }
  }
}
</script>
<style>
@import './diseaseTypeNew.css';
</style>